export const defaultAvatar = require('@/assets/sndle-avatar-default.png')

export const getContactImg = (contact) => {
  if (!contact) return ''
  let img = contact.avatarImg
  const gender = contact.gender
  const sndleAvatarDefault = require('@/assets/sndle-avatar-default.png')
  const sndleAvatarFemale = require('@/assets/sndle-avatar-female.png')
  const sndleAvatarMale = require('@/assets/sndle-avatar-male.png')
  if (!img) {
    switch (gender) {
      case 1:
        img = sndleAvatarMale
        break
      case 2:
        img = sndleAvatarFemale
        break
      default:
        img = sndleAvatarDefault
        break
    }
  } else {
    const STATIC_URL = process.env.VUE_APP_STATIC_URL
    img = STATIC_URL + img
  }
  return img
}

export const contactMapGetters = {
  allContacts: 'contact/getAllContacts',
  contactTotalCount: 'contact/getTotalCount',
  contactImgByIndex: 'contact/getAvatarImgByIndex',
  contactTitleByIndex: 'contact/getTitleByIndex',
  contactOrganizationByIndex: 'contact/getOrganizationByIndex',
  skipQueryNewContact: 'contact/getSkipQueryNewContact',
  getNewContactByNumberVariables: 'contact/getQueryNewContactByNumberVariables'
}

export const contactMapActions = {
  initContacts: 'contact/init',
  clearContacts: 'contact/clear',
  appendContacts: 'contact/next',
  prependContacts: 'contact/unshift',
  setTotalCount: 'contact/setTotalCount'
}

export const categoryMapActions = {
  initCategories: 'category/init',
  appendCategories: 'category/next',
  clearCategories: 'category/clear'
}

export const groupMapActions = {
  initGroups: 'group/init',
  appendGroups: 'group/next',
  clearGroups: 'group/clear'
}

export const workHistoryMapActions = {
  initOrgs: 'workHistory/initOrgs',
  appendOrgs: 'workHistory/nextOrgs',
  clearOrgs: 'workHistory/clearOrgs',
  initTitles: 'workHistory/initTitles',
  appendTitles: 'workHistory/nextTitles',
  clearTitles: 'workHistory/clearTitles'
}

export const automationMapActions = {
  initRules: 'automation/init',
  updateRule: 'automation/updateRule',
  createRule: 'automation/createRule',
  setQueryStatus: 'automation/setLoadingStatus',
  setQueryStatusMessage: 'automation/setStatusMessage',
  updateProfileRuleByIndex: 'automation/updateProfileRuleByIndex',
  updateRuleNameByIndex: 'automation/updateRuleNameByIndex',
  updateRuleTypeByIndex: 'automation/updateRuleTypeByIndex',
  updateRepeatedByIndex: 'automation/updateRepeatedByIndex',
  updateApplyToNewByIndex: 'automation/updateApplyToNewByIndex',
  updateFrequencyByIndex: 'automation/updateFrequencyByIndex',
  updateSkipContactedWithinByIndex: 'automation/updateSkipContactedWithinByIndex',
  updateRemindDaysByIndex: 'automation/updateRemindDaysByIndex',
  updateApplyToBirthdayByIndex: 'automation/updateApplyToBirthdayByIndex',
  updateApplyToAllByIndex: 'automation/updateApplyToAllByIndex',
  updateScheduledDateTimeByIndex: 'automation/updateScheduledDateTimeByIndex',
  updateTimeZoneByIndex: 'automation/updateTimeZoneByIndex',
  updateRuleMessageByIndex: 'automation/updateRuleMessageByIndex',
  deleteRule: 'automation/deleteRule',
  appendRules: 'automation/next',
  clearRules: 'automation/clear'
}
